import { useMemo } from 'react';
import NsContent from 'components/common/ns-content/NsContent';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsForm } from 'components/common/ns-form/NsForm';
import { Error } from 'components/common/error/Error';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';

import { MeterReadsGuide } from 'components/direct-sales/meter-reads/components/MeterReadsGuide';
import { MeterReadsForm } from 'components/direct-sales/meter-reads/components/MeterReadsForm';
import { MeterReadsTop } from 'components/direct-sales/meter-reads/components/MeterReadsTop';
import { useMeterRead } from 'components/direct-sales/meter-reads/hooks/useMeterRead';

export const testId = 'meter-reads';

export const MeterReads = () => {
  const {
    errors,
    hasReachedMaxAttemps,
    hasCta,
    isLoading,
    handleSubmit
  } = useMeterRead();

  return useMemo(() => {
    return (
      <NsPanel testId={testId}>
        <MeterReadsTop />
        <NsForm onSubmit={handleSubmit} id="meter-read-form">
          <MeterReadsForm />
          <NsContent>
            <MeterReadsGuide />
            <Error errors={errors} />
          </NsContent>

          {hasCta && (
            <NsPrimaryCta testId="meter-reads-cta" isLoading={isLoading}>
              {hasReachedMaxAttemps
                ? 'Continue with estimated readings'
                : 'Continue'}
            </NsPrimaryCta>
          )}
        </NsForm>
      </NsPanel>
    );
  }, [handleSubmit, errors, hasReachedMaxAttemps, hasCta, isLoading]);
};

export default MeterReads;
